import { Turnstile } from '@marsidev/react-turnstile';
import Box from '@mui/material/Box';
import React from 'react';
import { RuntimeConfiguration } from '@/configuration';
import { useAccessToken } from '../providers/AccessTokenProvider';
import { StorageService } from '../services';

const SecurityContainer = () => {
  const { setAccessToken } = useAccessToken();

  const handleCaptcha = React.useCallback(
    async (token: string) => {
      setAccessToken(token);
      StorageService.accessToken.setValue(token);
    },
    [setAccessToken]
  );

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '16px'
      }}
    >
      <Turnstile
        siteKey={RuntimeConfiguration.CLOUD_FLARE_SECRET_KEY}
        onError={() => console.log('error')}
        onExpire={() => console.log('expired')}
        onSuccess={handleCaptcha}
      />
    </Box>
  );
};

export default SecurityContainer;
